import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { HelpDeskColored, LiveChatColored } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, SpacingToken } from "@livechat/design-system-react-components";

import imageSrc from "assets/img/welcome/manageable-tickets.png";
import Text from "components/layout/Text";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { AgentActions } from "store/entities/agents";
import { getCurrentAgentId } from "store/features/session";
import { withVar } from "themes/helpers";

import { WelcomeTutorialRoutes } from "../helpers";

import TitleOnboardingStep from "./TitleOnboardingStep";

interface IProps {
  shouldDisplayImportDataStep: boolean;
}

const ManageableTicketsStep: FC<IProps> = ({ shouldDisplayImportDataStep }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentAgentId = useSelector(getCurrentAgentId);

  const handleNextButtonClick = (): void => {
    if (shouldDisplayImportDataStep) {
      history.push(WelcomeTutorialRoutes.LC_IMPORT_DATA);
    } else {
      history.push(WelcomeTutorialRoutes.FINISH);
      trackEngagement("LC integration: Welcome screens finished", EventPlace.Onboarding);
      dispatch(
        AgentActions.finishWelcomeTutorial({
          // @ts-expect-error TS(2322)
          id: currentAgentId,
          flags: {
            visitedWelcomeTutorial: true,
          },
        })
      );
    }
  };

  useEffect(() => {
    trackEngagement("LC integration: Welcome screens", EventPlace.Onboarding, {
      step: 3,
    });
  }, []);

  return (
    <TitleOnboardingStep
      currentStep={3}
      title={
        <Text
          // TODO: replace with Heading component when DS adds new size
          fontWeight="600"
          fontSize="40px"
          lineHeight="54px"
          color={withVar(DesignToken.ContentBasicPrimary)}
          marginV={withVar(SpacingToken.Spacing4)}
        >
          Create manageable tickets directly <br /> from chats
        </Text>
      }
      subtitle={<>Turn complex chats into tickets when you need extra time to solve customer cases.</>}
      imageSource={imageSrc}
      firstIcon={<Icon source={HelpDeskColored} />}
      secondIcon={<Icon source={LiveChatColored} />}
      backButtonRouteLink={WelcomeTutorialRoutes.LC_TICKET_FORM}
      nextButton={
        <Button size="large" kind="primary" onClick={handleNextButtonClick}>
          Continue
        </Button>
      }
    />
  );
};

export default ManageableTicketsStep;
